import { VestingChartDataRes, VestingTermTimeUnitType } from '@dealstack/shared/lib/generated';
import { DateTime } from 'luxon';

export const getDomainStart = (input: number): number => {
	return DateTime.fromMillis(input).toMillis();
};

export const getDomainEnd = (input: number): number => {
	return DateTime.fromMillis(input)
		.plus({
			months: 1,
		})
		.toMillis();
};

export const xDomain = [
	(dataMin: number) => getDomainStart(dataMin),
	(dataMax: number) => getDomainEnd(dataMax),
] as [(input: number) => number, (input: number) => number];

export const xTicks = (chartData: VestingChartDataRes[], optionPeriod: VestingTermTimeUnitType) => {
	const firstReleaseDate = chartData[0]?.date;
	const ticks: number[] = [];
	let t: DateTime = DateTime.fromMillis(firstReleaseDate);

	while (t.toMillis() <= chartData[chartData.length - 1].date) {
		ticks.push(t.toMillis());

		if (optionPeriod === VestingTermTimeUnitType.YEARLY) {
			t = t.plus({
				years: 1,
			});
		} else {
			t = t.plus({
				months: 1,
			});
		}
	}

	return ticks;
};

export const yTicksPercent = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const yDomain = [yTicksPercent[0], yTicksPercent[yTicksPercent.length - 1]];
